import React from 'react';

import DashboardWidgetWrapper from '../DashboardWidgetWrapper';

const SubscriptionMetricsWidget = (props) => {
	return (
		<DashboardWidgetWrapper label={'Subscription Metrics'}>
			<p>Hello</p>
		</DashboardWidgetWrapper>
	);
};

SubscriptionMetricsWidget.propTypes = {};

export default SubscriptionMetricsWidget;
